import { useEffect, useRef, useState } from "react";
import { Play } from "lucide-react";

const VideoSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-16 md:py-24 bg-background" ref={ref}>
      <div className="max-w-4xl mx-auto section-padding">
        <div className={`text-center mb-10 ${visible ? "reveal-up" : "opacity-0"}`}>
          <p className="text-accent font-semibold text-sm tracking-wide uppercase mb-3">
            See It in Action
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground tracking-tight mb-4">
            20 Years of Dental Marketing in Action
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto leading-relaxed">
            From $1M to $12M — watch how we built, tested, and perfected the playbook that grows dental practices nationwide.
          </p>
        </div>

        <div className={`${visible ? "reveal-up" : "opacity-0"}`} style={{ animationDelay: "150ms" }}>
          <div className="aspect-video rounded-xl overflow-hidden shadow-xl ring-1 ring-border">
            <iframe
              src="https://www.youtube-nocookie.com/embed/OcNuj6ic6Ak"
              title="Dental Marketing Specialists - XPress Promotion"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
